import * as XLSX from "xlsx";

export const handleExportarExcel = (egresos, filtroMes, filtroAnio, filtroSucursal, sucursales) => {
  // Filtrar egresos por mes, año y sucursal
  const egresosFiltrados = egresos.filter((e) => {
    const fecha = new Date(e.fecha_registro);
    const mes = (fecha.getUTCMonth() + 1).toString();
    const anio = fecha.getUTCFullYear().toString();
    return (
      (!filtroMes || mes === filtroMes) &&
      (!filtroAnio || anio === filtroAnio) &&
      (!filtroSucursal || e.branch_id?.toString() === filtroSucursal)
    );
  });

  // Calcular total del filtro
  const total = egresosFiltrados.reduce((sum, e) => sum + parseFloat(e.monto || 0), 0);

  // Obtener nombre de sucursal
  const getSucursalName = (id) =>
  sucursales.find((s) => s.id.toString() === id.toString())?.name || "Sin Sucursal";

  // Preparar datos para Excel
  const dataExcel = egresosFiltrados.map((e) => ({
    Sucursal: getSucursalName(e.branch_id),
    Tipo: e.tipo,
    Descripción: e.descripcion,
    Fecha: new Date(e.fecha_registro).toLocaleDateString("es-CL", { timeZone: "UTC" }),
    Monto: new Intl.NumberFormat("es-CL", {
      style: "currency",
      currency: "CLP",
      minimumFractionDigits: 0,
    }).format(e.monto || 0),
  }));

  // Crear hoja con encabezados personalizados
  const ws = XLSX.utils.json_to_sheet(dataExcel, {
    header: ["Sucursal", "Tipo", "Descripción", "Fecha", "Monto"],
    skipHeader: true,
    origin: "A2",
  });

  // Agregar encabezado manual
  XLSX.utils.sheet_add_aoa(ws, [["Sucursal", "Tipo", "Descripción", "Fecha", "Monto"]], {
    origin: "A1",
  });

  // Agregar fila total
  const totalRowIndex = dataExcel.length + 1;
  XLSX.utils.sheet_add_aoa(
    ws,
    [["", "", "TOTAL", "", new Intl.NumberFormat("es-CL", {
      style: "currency",
      currency: "CLP",
      minimumFractionDigits: 0,
    }).format(total)]],
    { origin: -1 }
  );

  // Ajustar ancho de columnas
  ws["!cols"] = [
    { wch: 25 },
    { wch: 20 },
    { wch: 40 },
    { wch: 15 },
    { wch: 15 },
  ];

  // Crear y guardar archivo Excel
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Egresos");
  XLSX.writeFile(
    wb,
    `Egresos_${filtroSucursal || "Todas"}_${filtroMes || "Todos"}_${filtroAnio || "Todos"}.xlsx`
  );
};
